import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular/lazy';

@Component({
    selector: 'popover',
    templateUrl: './popover.page.html',
    styleUrls: ['./popover.page.scss'],
    standalone: false
})
export class Popover implements OnInit {
  @Input() compare?: boolean;
  @Input() favProvider?: boolean;

  constructor(public popoverController: PopoverController) { }

  ngOnInit(): void {
    console.log(this.favProvider, this.compare);
  }

  favProv(value: string): void {
    this.popoverController.dismiss(value);
  }
}